import { useTranslation } from 'react-i18next';

const donutKeys = ['chocolate', 'vanilla', 'simpsons', 'boston'];

export default function MenuPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-pink-50 dark:bg-gray-900 min-h-screen text-gray-800 dark:text-gray-100 p-6">
      <h1 className="text-3xl font-bold text-center mb-8">{t('menu.title')}</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {donutKeys.map((key) => (
          <div
            key={key}
            className="bg-white dark:bg-gray-800 rounded-2xl shadow-md p-4 text-center"
          >
            <img
              src={`/images/${key}-donut.jpg`}
              alt={t(`menu.items.${key}.name`)}
              className="w-full h-48 object-cover rounded-xl mb-4"
            />
            <h2 className="text-xl font-semibold">{t(`menu.items.${key}.name`)}</h2>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {t(`menu.items.${key}.description`)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
